'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dimmer = require('./Dimmer');

var _Dimmer2 = _interopRequireDefault(_Dimmer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dimmer2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/dist/commonjs/modules/Dimmer/index.js
 ** module id = 1681
 ** module chunks = 0
 **/